export const Roles = {
    User: 1 << 0, // 1
    Retail: 1 << 1, // 2
    Wholesale: 1 << 2, // 4
    Manufacturing : 1 << 3, // 8
    Customer : 1 << 4, // 16
    BankingIntegration : 1 << 5, // 32
    Marketplace: 1 << 6, // 64
    ECommerce: 1 << 7, // 128
    Muhasebe: 1 << 8, // 256
    Admin: 1 << 10, // 1024
    SuperAdmin: 1 << 11 // 2048
  };